export interface AiProcessingStats {
  total: number;
  processing: number;
  completed: number;
  failed: number;
  percentage: number;
}

export interface AiProcessingItem {
  id: string;
  assetId: string;
  assetType: string;
  assetName: string;
  status: 'PROCESSING' | 'COMPLETED' | 'FAILED';
  percentage: number;
  startedAt: string;
  completedAt: string | null;
  metadata: Record<string, string>;
}

export interface AiProcessingSummary {
  stats: AiProcessingStats;
  items: AiProcessingItem[];
}

export enum FileClassificationType {
  CERTIFICATE = 'CERTIFICATE',
  AUDIT = 'AUDIT',
  DOCUMENT = 'DOCUMENT',
  OTHER = 'OTHER',
}

export const FILE_CLASSIFICATION_OPTIONS = [
  { key: FileClassificationType.AUDIT, text: 'Audit' },
  { key: FileClassificationType.CERTIFICATE, text: 'Certificate' },
  { key: FileClassificationType.DOCUMENT, text: 'Document' },
  { key: FileClassificationType.OTHER, text: 'Other' },
];

export interface ClassifyResultClassification {
  type: string;
  confidence: number;
  reasoning: string;
}

export interface ClassifyResultItem {
  fileId: string;
  aiProcessingJobId: string;
  status: 'completed' | 'processing' | 'pending' | 'failed';
  classification: ClassifyResultClassification | null;
  error: string | null;
}

export interface ClassifyResultsResponse {
  results: ClassifyResultItem[];
}

export interface CompanyDocumentProcess {
  id: string;
  fileId: string;
  status: string;
  percentage: number;
  workflows: string[];
  finishedWorkflows: string[];
  metadata: Record<string, unknown>;
  createdAt: string;
  updatedAt: string | null;
}
